import type { ContentBuilder } from '../../ui/ContentBuilder';
import type { SettlementView } from '../utils';
import { getWarnings } from '../utils';
import { t, type Language } from '../../../i18n/translations';

export function renderLogTab(
    builder: ContentBuilder,
    settlement: SettlementView,
    lang: Language,
): void {
    builder.section(t(lang, 'log.section'), (section) => {
        const warnings = getWarnings(lang, settlement);
        if (warnings.length === 0) {
            section.text(t(lang, 'log.none'));
            return;
        }
        warnings.forEach((warning) => section.text(`- ${warning}`));
    });
}
